export default __webpack_public_path__ + "static/media/44.5247d307.gif";